import { mask } from 'maska'

// Formato canônico usado no resto do app (ex.: SignUp de empresa e de contratante).
const CNPJ_MASK = '##.###.###/####-##'

/** Máscara progressiva para digitação — idempotente, aceita valor já mascarado. */
export const maskCnpjInput = (value: string | number | null | undefined): string =>
  value === null || value === undefined ? '' : mask(String(value), CNPJ_MASK)

/** Só os dígitos — formato em que o backend armazena o CNPJ. */
export const cnpjDigits = (value: string | null | undefined): string =>
  (value ?? '').replace(/\D/g, '')

/** Exibição: só formata CNPJ completo; devolve o valor original caso contrário. */
export const formatCnpj = (value: string | null | undefined): string => {
  const digits = cnpjDigits(value)
  return digits.length === 14 ? maskCnpjInput(digits) : (value ?? '')
}
